import VisualizarCompraInformacoesPagamento from './VisualizarCompraInformacoesPagamento';

export default VisualizarCompraInformacoesPagamento;
